import React from 'react';
import { Form } from 'react-bootstrap';
import { FormField } from './FormField';

export function OutputField(props) {
    return (
        <Form.Group>
            <FormField {...props} readOnly disabled />
        </Form.Group>
    );
}
